import './App.css';
import React, { useState } from 'react';
import logo from './assets/logodron-escalet-02.svg'; // Tu logo
import fons from './assets/background.jpg'; // Tu fondo

function Login(props) {
    const url = process.env.REACT_APP_API_URL;
    const [user, setUser] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    async function logIn(e) {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            let options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                },
                body: JSON.stringify({
                    "email": user.email,
                    "password": user.password,
                })
            };

            let response = await fetch(url + '/login', options);
            
            if (response.ok) {
                var dataReceived = await response.json();
                localStorage.setItem('token', dataReceived.token);
                localStorage.setItem('Login', user.email);
                localStorage.setItem('role', dataReceived.role);
                
                // Actualizamos el estado global en App.js
                props.setToken(dataReceived.token);
                props.setRole(dataReceived.role);
                
                // Forzamos una recarga limpia para asegurar que el enrutador lea el token
                window.location.href = '/'; 
            } else {
                setError("Credenciales incorrectas. Inténtalo de nuevo.");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError("Error connecting to the server.");
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="login-wrapper" style={{ backgroundImage: `url(${fons})` }}>
            <div className="login-card">
                <img src={logo} alt="Logo DEADER" className="login-logo" />
                <h3 className="login-title">REMOTE CONTROL</h3>
                
                <form onSubmit={logIn} className="login-form">
                    <div className="form-group">
                        <label>Email</label>
                        <input 
                            type="email" 
                            placeholder="user@email.com" 
                            required
                            onChange={(e) => setUser({ ...user, email: e.target.value })} 
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input 
                            type="password" 
                            placeholder="••••••••" 
                            required
                            onChange={(e) => setUser({ ...user, password: e.target.value })} 
                        />
                    </div>

                    {/* Si hay error, lo mostramos aquí */}
                    {error && <div className="login-error">{error}</div>}

                    <button 
                        type="submit" 
                        className={`btn-pill login-btn ${isLoading ? 'cooldown-state' : ''}`}
                        disabled={isLoading}
                    >
                        {isLoading ? "CONNECTING..." : "LOG IN"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;